import React from 'react';
import PropTypes from 'prop-types';
import { WEATHER_CODES, SVG, PASCAL } from '../constants';
import { capitalizeWeatherCode } from '../utils';

const propTypes = {
  weather: PropTypes.object
};

const WeatherDislay = ({ weather }) => {
  return (
    <div>
      <div style={{ display: 'flex', 'flexDirection': 'row', 'justifyContent': 'center' }}>
        <span className="pl-10">{ weather ? <i className={`wi ${WEATHER_CODES[weather.weather_code]} medium intro-title`}></i> : '' }</span>
        <span className="pl-10"><h4 className="intro-title">{ weather ? capitalizeWeatherCode(weather.weather_code) : '' }</h4></span>
      </div>
      <div className="row">
        <div className="col s12 m6 l6 xl6">
          <ul className="collection">
            <li className="collection-item avatar">
              <span className="circle2"><i className="wi wi-thermometer small"></i></span>
              <span className="label2">Temperature</span><br />
              <span className="title2">{ weather ? weather.temp : 'N/A' } <i className="wi wi-fahrenheit"></i></span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><i className="wi wi-humidity small"></i></span>
              <span className="label2">Humidity</span><br />
              <span className="title2">{ weather ? weather.humidity : 'N/A' }%</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><i className="wi wi-raindrops small"></i></span>
              <span className="label2">Precipitation</span><br />
              <span className="title2">{ weather ? weather.precipitation : 'N/A' } in/hr</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><i className="wi wi-windy small"></i></span>
              <span className="label2">Wind Speed</span><br />
              <span className="title2">{ weather ? weather.wind_speed : 'N/A' } mph</span>
            </li>
          </ul>
        </div>
        <div className="col s12 m6 l6 xl6">
          <ul className="collection">
            <li className="collection-item avatar">
              <span className="circle2"><i className="wi wi-barometer small"></i></span>
              <span className="label2">Barometric Pressure</span><br />
              <span className="title2">{ weather ? (Number(weather.baro_pressure) * PASCAL).toFixed(2) : 'N/A' } hPA</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><i className="wi wi-cloudy small"></i></span>
              <span className="label2">Cloud Cover</span><br />
              <span className="title2">{ weather ? weather.cloud_cover : 'N/A' }%</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><img height={"40px"} width={"40px"} src={SVG.surface_shortwave_radiation} alt={''} /></span>
              <span className="label2">Surface Shortwave Radiation</span><br />
              <span className="title2">{ weather ? weather.surface_shortwave_radiation : 'N/A' } Btu/ft{"\u00B2"}</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><i className="wi wi-strong-wind small"></i></span>
              <span className="label2">Wind Gust</span><br />
              <span className="title2">{ weather ? weather.wind_gust : 'N/A' } mph</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
WeatherDislay.propTypes = propTypes;
export default WeatherDislay;



// WEBPACK FOOTER //
// ./src/weather/components/weather_display.js